<template>
  <BaseDialog
    v-model="isVisible"
    content-width="1043px"
    close
  >
    <BaseCard
      class="m_bg-accent-gradient m_pb51 m_pt42 m_px16 m_flex m_flex-column m_border-none m_align-center"
    >
      <BaseText
        v-if="title"
        tag="div"
        class="m_my-auto m_sh6 m_bold m_mw740 m_text-center mm_sh1"
        :class="{'m_mb16': message.length}"
        v-html="title"
      >
      </BaseText>
      <BaseText
        v-if="message.length"
        tag="div"
        class="m_my-auto m_h1 m_mw740 m_text-center m_mb50 mm_h4 mm_mb16"
      >
        <div class="m_mb16">
          <p
            v-for="(m, i) in message"
            :key="'message' + i"
          >
            {{ m }}
            <span
              v-if="!m"
              class="separation"
            >&nbsp;</span>
          </p>
        </div>
      </BaseText>
      <div class="m_flex m_gap10 m_flex-wrap m_justify-center m_align-center">
        <BaseButton
          v-if="activeButton && activeButtonCallback"
          class="m_h46 m_w215 m_font-big m_border-none plc_email-request-submit-input"
          @click="activeButtonCallback?.();isVisible=false"
        >
          {{ activeButton }}
        </BaseButton>
        <BaseButton
          class="m_h46 m_w215 m_font-big m_border-none plc_email-request-submit-input"
          variant="accent"
          @click="isVisible=false"
        >
          Закрыть
        </BaseButton>
      </div>
    </BaseCard>
  </BaseDialog>
</template>

<script lang="ts">
import BaseCard from '@/shared/lib/uikit/components/BaseCard/BaseCard.vue';
import BaseText from '@/shared/lib/uikit/components/BaseText/BaseText.vue';
import BaseDialog from '@/shared/lib/uikit/components/BaseDialog/BaseDialog.vue';
import {
  defineComponent,
  ref,
  watch,
} from 'vue';
import emitter from '@/shared/services/emitter';
import BaseButton from '@/shared/lib/uikit/components/BaseButton/BaseButton.vue';

export default defineComponent({
  name: 'AppYellowModal',
  components: {
    BaseButton,
    BaseCard,
    BaseText,
    BaseDialog,
  },
  setup() {
    const isVisible = ref(false);
    const message = ref([]);
    const title = ref('');
    const activeButton = ref(null);
    const activeButtonCallback = ref<null | Function>(null);

    watch(isVisible, visible => {
      if (!visible) {
        activeButtonCallback.value = null;
        activeButton.value = null;
      }
    });

    emitter.on('yellowModal', (data: any) => {
      isVisible.value = true;
      title.value = data.title;
      message.value = data.message.split('\n');
      if (message.value.length === 1 && !message.value[0]) {
        message.value = [];
      }
      activeButton.value = data.activeButton ?? null;
      activeButtonCallback.value = data.activeButtonCallback ?? null;
    });

    return {
      isVisible,
      message,
      title,
      activeButton,
      activeButtonCallback,
    };
  },
});
</script>

<style lang="scss" scoped>
p:has(.separation) {
  height: rem(10);
}
</style>
